var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeDiners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "SVGInline-svg SVGInline--cleaned-svg SVG-svg BrandIcon-svg BrandIcon--size--32-svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6F8",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.319 8.022V8h5.263v.022C22.707 8.328 25.9 11.809 25.9 16c0 4.192-3.193 7.673-7.318 7.979V24h-5.263v-.021C9.193 23.673 6 20.192 6 16c0-4.191 3.193-7.672 7.319-7.978Z",
    fill: "#0165AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.053 16c0 3.83 3.063 6.934 6.842 6.934 3.779 0 6.842-3.105 6.842-6.934s-3.063-6.933-6.842-6.933c-3.779 0-6.842 3.104-6.842 6.933Zm5.263-4.522c-1.889.68-3.15 2.491-3.15 4.522s1.261 3.843 3.15 4.523v-9.045Zm3.158 9.045c1.888-.68 3.15-2.492 3.15-4.523 0-2.03-1.262-3.842-3.15-4.522v9.045Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeDiners);
export default __webpack_public_path__ + "static/media/stripe_diners.e3064a10d109e1c42713ddab5415a29e.svg";
export { ForwardRef as ReactComponent };